<template>
  <div id="app" class="container-fluid">
    <mensaje />
    <div class="card">
      <div class="card-header p-2 m-1">
        <div class="card-title m-0">
          <button class="btn btn-primary btn-sm" @click="volver">Volver</button>
          <strong>Formulario para postularse a Clinica Parque</strong>
        </div>
      </div>
      <div class="card-body p-1">
        <pasos class="mb-4" />
        <keep-alive>
          <component :is="currentTabComponent" v-on:continuar="continuar"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  import Paso1 from './components/Paso1';
  import Paso2 from './components/Paso2';
  import Paso3 from './components/Paso3';
  import Paso4 from './components/Paso4';
  import Mensaje from './components/Mensaje';
  import Pasos from './components/Pasos';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    data: () => ({
      currentTabComponent: 'paso1'
    }),
    computed: {
      ...mapGetters({
        postulante: 'postulante/getData'
      })
    },
    methods: {
      ...mapActions({
        fetchSectores: 'sectores/fetchData',
        fetchNiveles: 'nivel_estudio/fetchData'
      }),
      continuar(paso) {
        this.currentTabComponent = 'paso' + paso;
      },
      volver: function() {
        // console.log('Cerrar ventana!');
        window.location.href = "http://www.clinicaparque.com.ar";
      }
    },
    mounted() {
      this.fetchSectores();
      this.fetchNiveles();
    },
    components: {
      pasos: Pasos,
      paso1 : Paso1,
      paso2 : Paso2,
      paso3 : Paso3,
      paso4 : Paso4,
      mensaje: Mensaje
    }
  }

</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/App.vue